export default "__VITE_ASSET__af4431b4__"